/* eslint-disable */

import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import ModelTag from "../model-tag/model-tag";
import { useState } from "react";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import Currency from "../currency/currency.tsx";
import { fetchGraphQL } from "../../services/api-raindrop.js";

const ModelComponentOrganisationActivity = ({
  id = "organisation_activity__1234fake",
  heading = "Fake test data",
}) => {
  const [isDeleted, setIsDeleted] = useState(false);

  const onDelete = () => {
    fetchGraphQL(`
      mutation {
        organisationActivityDelete(
          organisationActivityId: "${id}"
        ) {
          id
        }
      }
      `).then((response) => {
      if (response.data.organisationActivityDelete) {
        setIsDeleted(true);
        return;
      } else {
        console.error(
          "RD-5543 - Error deleting organisation activity",
          response
        );
      }
    });
  };

  if (isDeleted) {
    return (
      <div className="flex flex-col gap-4 w-full max-w-md p-4 rounded-lg border border-l-4 dark:border-l-color-dark-model-organisation-activity border-l-color-model-organisation-activity dark:border-color-dark-border-secondary border-color-border-secondary dark:bg-color-dark-background-secondary bg-color-background-secondary">
        <p>Organisation activity deleted successfully.</p>
      </div>
    );
  }

  return (
    <div
      className={`flex flex-col gap-4 w-full max-w-md 
       p-4 rounded-lg border border-l-4 
      dark:border-l-color-dark-model-organisation-activity border-l-color-model-organisation-activity
      dark:border-color-dark-border-secondary border-color-border-secondary 
      dark:bg-color-dark-background-secondary bg-color-background-secondary
       `}
    >
      <ModelTag modelId={id} />

      <RaindropInput
        label="Heading"
        value={heading}
        isEditing={false}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />

      <RaindropButton title="Delete" onClick={onDelete} />
    </div>
  );
};

export default ModelComponentOrganisationActivity;
